define("shared/components/shared/credentials/tiktok-refresh", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Portal @destinationElement="root-portal">
    <Shared::Modal @closable={{false}} as |modal|>
      <modal.card @closeIcon={{false}} @portrait={{true}}>
        <modal.card-header>
          <h2 class="o--modalHeader__title">{{t "tiktok.refresh.title"}}</h2>
          <p class="u--p__t__xs">{{t "tiktok.refresh.subtitle"}}</p>
        </modal.card-header>
        <modal.card-body class="u--p__t__0">
          <div class="tAC--status tAC--status--danger">
            <div class="u--row u--row--noCollapse">
              <div class="u--col__8">
                <div>
                  <Shared::ProfileAvatar @showPlatform={{true}} @socialProfile={{this.tiktokProfile}}>
                    <span class="o--user__title u--text--hair u--text--danger">
                      {{this.tiktokProfile.nickname}}
                    </span>
                    <span class="o--user__desc u--text--danger">
                      {{t "shared_words.tiktok"}}
                    </span>
                  </Shared::ProfileAvatar>
                </div>
              </div>
              <Shared::Ui::Button
                @class="u--m__r__sm u--float--right u--text--danger"
                @onClick={{set this "showTiktokRefreshConfirmationModal" true}}
                @variant="outline"
                data-test-id="tiktok-refresh-button"
              >
                <span>
                  {{t "shared_words.refresh"}}
                  {{svg-jar "refresh" class="o--icon u--m__l__xs"}}
                </span>
              </Shared::Ui::Button>
            </div>
          </div>
  
          <div class="o--card u--m__t__md">
            <div class="o--cardBody u--p__lr">
              <p class="u--text--bold u--m__b">
                {{t
                  "shared_phrases.feature_refresh_required.missing_features"
                  profileType=this.tiktokProfile.accountType
                }}
              </p>
              <ul class="u--listUnstyle u--row">
                <li class="u--col__6">
                  {{svg-jar "warning" class="o--icon o--icon--danger u--m__b__xs"}}
                  {{t "shared_phrases.publish_post"}}
                </li>
                <li class="u--col__6">
                  {{svg-jar "warning" class="o--icon o--icon--danger u--m__b__xs"}}
                  {{t "shared_words.linkinbio"}}
                </li>
              </ul>
            </div>
          </div>
        </modal.card-body>
        <modal.card-footer>
          <Shared::Ui::Button
            @additional="block"
            @onClick={{@closeTiktokRefreshModal}}
            @text={{t "shared_words.close"}}
            @variant="outline"
            data-test-id="tiktok-refresh-close-button"
          />
        </modal.card-footer>
      </modal.card>
    </Shared::Modal>
  </Shared::Portal>
  
  {{#if this.showTiktokRefreshConfirmationModal}}
    <Shared::Portal @destinationElement="root-portal">
      <Shared::Credentials::TiktokRefreshConfirm
        @handleClose={{set this "showTiktokRefreshConfirmationModal" false}}
        @refreshUnverifiedTiktok={{this.refreshUnverifiedTiktok}}
      />
    </Shared::Portal>
  {{/if}}
  */
  {
    "id": "4CLhin+c",
    "block": "[[[8,[39,0],null,[[\"@destinationElement\"],[\"root-portal\"]],[[\"default\"],[[[[1,\"\\n  \"],[8,[39,1],null,[[\"@closable\"],[false]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card\"]],null,[[\"@closeIcon\",\"@portrait\"],[false,true]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,1,[\"card-header\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[10,\"h2\"],[14,0,\"o--modalHeader__title\"],[12],[1,[28,[35,2],[\"tiktok.refresh.title\"],null]],[13],[1,\"\\n        \"],[10,2],[14,0,\"u--p__t__xs\"],[12],[1,[28,[35,2],[\"tiktok.refresh.subtitle\"],null]],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[30,1,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n        \"],[10,0],[14,0,\"tAC--status tAC--status--danger\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"u--row u--row--noCollapse\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"u--col__8\"],[12],[1,\"\\n              \"],[10,0],[12],[1,\"\\n                \"],[8,[39,3],null,[[\"@showPlatform\",\"@socialProfile\"],[true,[30,0,[\"tiktokProfile\"]]]],[[\"default\"],[[[[1,\"\\n                  \"],[10,1],[14,0,\"o--user__title u--text--hair u--text--danger\"],[12],[1,\"\\n                    \"],[1,[30,0,[\"tiktokProfile\",\"nickname\"]]],[1,\"\\n                  \"],[13],[1,\"\\n                  \"],[10,1],[14,0,\"o--user__desc u--text--danger\"],[12],[1,\"\\n                    \"],[1,[28,[35,2],[\"shared_words.tiktok\"],null]],[1,\"\\n                  \"],[13],[1,\"\\n                \"]],[]]]]],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n            \"],[8,[39,4],[[24,\"data-test-id\",\"tiktok-refresh-button\"]],[[\"@class\",\"@onClick\",\"@variant\"],[\"u--m__r__sm u--float--right u--text--danger\",[28,[37,5],[[30,0],\"showTiktokRefreshConfirmationModal\",true],null],\"outline\"]],[[\"default\"],[[[[1,\"\\n              \"],[10,1],[12],[1,\"\\n                \"],[1,[28,[35,2],[\"shared_words.refresh\"],null]],[1,\"\\n                \"],[1,[28,[35,6],[\"refresh\"],[[\"class\"],[\"o--icon u--m__l__xs\"]]]],[1,\"\\n              \"],[13],[1,\"\\n            \"]],[]]]]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\\n        \"],[10,0],[14,0,\"o--card u--m__t__md\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"o--cardBody u--p__lr\"],[12],[1,\"\\n            \"],[10,2],[14,0,\"u--text--bold u--m__b\"],[12],[1,\"\\n              \"],[1,[28,[35,2],[\"shared_phrases.feature_refresh_required.missing_features\"],[[\"profileType\"],[[30,0,[\"tiktokProfile\",\"accountType\"]]]]]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,\"ul\"],[14,0,\"u--listUnstyle u--row\"],[12],[1,\"\\n              \"],[10,\"li\"],[14,0,\"u--col__6\"],[12],[1,\"\\n                \"],[1,[28,[35,6],[\"warning\"],[[\"class\"],[\"o--icon o--icon--danger u--m__b__xs\"]]]],[1,\"\\n                \"],[1,[28,[35,2],[\"shared_phrases.publish_post\"],null]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,\"li\"],[14,0,\"u--col__6\"],[12],[1,\"\\n                \"],[1,[28,[35,6],[\"warning\"],[[\"class\"],[\"o--icon o--icon--danger u--m__b__xs\"]]]],[1,\"\\n                \"],[1,[28,[35,2],[\"shared_words.linkinbio\"],null]],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[39,4],[[24,\"data-test-id\",\"tiktok-refresh-close-button\"]],[[\"@additional\",\"@onClick\",\"@text\",\"@variant\"],[\"block\",[30,2],[28,[37,2],[\"shared_words.close\"],null],\"outline\"]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[1]]]]],[1,\"\\n\"]],[]]]]],[1,\"\\n\\n\"],[41,[30,0,[\"showTiktokRefreshConfirmationModal\"]],[[[1,\"  \"],[8,[39,0],null,[[\"@destinationElement\"],[\"root-portal\"]],[[\"default\"],[[[[1,\"\\n    \"],[8,[39,8],null,[[\"@handleClose\",\"@refreshUnverifiedTiktok\"],[[28,[37,5],[[30,0],\"showTiktokRefreshConfirmationModal\",false],null],[30,0,[\"refreshUnverifiedTiktok\"]]]],null],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[]],null]],[\"modal\",\"@closeTiktokRefreshModal\"],false,[\"shared/portal\",\"shared/modal\",\"t\",\"shared/profile-avatar\",\"shared/ui/button\",\"set\",\"svg-jar\",\"if\",\"shared/credentials/tiktok-refresh-confirm\"]]",
    "moduleName": "shared/components/shared/credentials/tiktok-refresh.hbs",
    "isStrictMode": false
  });
  let TiktokRefreshComponent = _exports.default = (_class = class TiktokRefreshComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "errors", _descriptor2, this);
      _initializerDefineProperty(this, "tiktok", _descriptor3, this);
      _initializerDefineProperty(this, "router", _descriptor4, this);
      _initializerDefineProperty(this, "showTiktokRefreshConfirmationModal", _descriptor5, this);
      _initializerDefineProperty(this, "tiktokProfile", _descriptor6, this);
      if (this.args.tiktokProfile) {
        this.tiktokProfile = this.args.tiktokProfile;
      } else {
        const tiktokSuccessProfileId = this.router.currentRoute.queryParams?.tiktok_success_connection;
        if (tiktokSuccessProfileId) {
          const connectedTiktokProfile = this.socialProfiles.find(profile => profile.id === tiktokSuccessProfileId);
          if (connectedTiktokProfile) {
            this.tiktokProfile = connectedTiktokProfile;
          } else {
            this.errors.log(new Error('Could not find tiktok_success_connection profile from available profiles'));
            this.router.transitionTo('cluster.schedule.calendar');
          }
        } else {
          this.errors.log(new Error('No Tiktok profile provided to refresh'));
          this.router.transitionTo('cluster.schedule.calendar');
        }
      }
    }
    get socialProfiles() {
      return this.auth.socialProfiles;
    }
    refreshUnverifiedTiktok() {
      const socialProfile = this.tiktokProfile;
      this.tiktok.refresh(socialProfile);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "tiktok", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "showTiktokRefreshConfirmationModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "tiktokProfile", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "refreshUnverifiedTiktok", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "refreshUnverifiedTiktok"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, TiktokRefreshComponent);
});